export enum LocaleId {
  en_US = 'en-US',
  es_ES = 'es-ES',
  de_DE = 'de-DE',
  fr_FR = 'fr-FR',
  ru_RU = 'ru-RU',
  hi_IN = 'hi-IN',
  ko_KR = 'ko-KR',
  th_TH = 'th-TH',
  ja_JP = 'ja-JP',
  zh_CN = 'zh-CN',
  he_IL = 'he-IL',
  ar_SA = 'ar-SA'
}

export const DEFAULT_LOCALE_ID: LocaleId = LocaleId.en_US;

export enum LanguageId {
  en = 'en',
  es = 'es',
  de = 'de',
  fr = 'fr',
  ru = 'ru',
  hi = 'hi',
  ko = 'ko',
  th = 'th',
  ja = 'ja',
  zh = 'zh',
  he = 'he',
  ar = 'ar'
}

export enum CountryId {
  US = 'US',
  ES = 'ES',
  DE = 'DE',
  FR = 'FR',
  RU = 'RU',
  IN = 'IN',
  KR = 'KR',
  TH = 'TH',
  JP = 'JP',
  CN = 'CN',
  IL = 'IL',
  SA = 'SA'
}

export function parseLocaleId(localeId: LocaleId): [LanguageId, CountryId | undefined] {
  const [language, country] = localeId.split('-') as [LanguageId, CountryId | undefined];
  return [language, country];
}

export function localeId(language: LanguageId, country?: CountryId): LocaleId {
  if (country) {
    return `${language}-${country}` as LocaleId;
  }
  return language as unknown as LocaleId;
}

const languagesByCountry: Record<CountryId, LanguageId[]> = (() => {
  const mapping = {} as Record<CountryId, LanguageId[]>;
  for (const country of Object.values(CountryId) as CountryId[]) {
    mapping[country] = [];
  }
  Object.values(LocaleId).forEach(locale => {
    const [lang, country] = locale.split('-') as [LanguageId, CountryId];
    const list = mapping[country];
    if (!list.includes(lang)) {
      list.push(lang);
    }
  });
  return mapping;
})();

export function languagesForCountry(country: CountryId): LanguageId[] {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  return languagesByCountry[country] || [];
}

const countriesByLanguage: Record<LanguageId, CountryId[]> = (() => {
  const mapping = {} as Record<LanguageId, CountryId[]>;
  for (const lang of Object.values(LanguageId) as LanguageId[]) {
    mapping[lang] = [];
  }
  for (const locale of Object.values(LocaleId)) {
    const [lang, country] = locale.split('-') as [LanguageId, CountryId];
    const list = mapping[lang];
    if (!list.includes(country)) {
      list.push(country);
    }
  }
  return mapping;
})();

export function countriesForLanguage(language: LanguageId): CountryId[] {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  return countriesByLanguage[language] || [];
}
